"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var types = _interopRequireWildcard(require("../mutation-types"));
var _menu_farm = _interopRequireDefault(require("../mock/menu_farm"));
var _menu_services = _interopRequireDefault(require("../mock/menu_services"));
var _menu_occurrences = _interopRequireDefault(require("../mock/menu_occurrences"));
var _menu_attendance_records = _interopRequireDefault(require("../mock/menu_attendance_records"));
var _menu_plants_nursery = _interopRequireDefault(require("../mock/menu_plants_nursery"));
var _menu_applications = _interopRequireDefault(require("../mock/menu_applications"));
var _menu_admin = _interopRequireDefault(require("../mock/menu_admin"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  items: [_menu_farm.default, _menu_services.default, _menu_occurrences.default, _menu_attendance_records.default, _menu_plants_nursery.default, _menu_applications.default, _menu_admin.default],
  farm: _menu_farm.default,
  services: _menu_services.default,
  occurrences: _menu_occurrences.default,
  attendanceRecords: _menu_attendance_records.default,
  plantsNursery: _menu_plants_nursery.default,
  applications: _menu_applications.default,
  admin: _menu_admin.default
};
var mutations = _defineProperty({}, types.TOGGLE_EXPAND_MENU_ITEM, function (state, payload) {
  var menuItem = payload.menuItem;
  var expand = payload.expand;
  if (menuItem.children && menuItem.meta) {
    menuItem.meta.expanded = expand;
  }
});
var actions = {
  toggleExpandMenuItem: function toggleExpandMenuItem(_ref, payload) {
    var commit = _ref.commit;
    commit(types.TOGGLE_EXPAND_MENU_ITEM, payload);
  }
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  actions: actions
};